import { render } from "./ArchaicTraits.vue?vue&type=template&id=50cdc275"
import script from "./ArchaicTraits.vue?vue&type=script&lang=js"
export * from "./ArchaicTraits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__